import React from 'react';
import raise from '../raise';
import { DEFAULT_TIMEOUT } from '../raise/constants';
import { default as Toast } from './Toast';
import { raiseToastProps } from './types';

const raiseToast = ({
  message,
  type = 'info',
  duration = DEFAULT_TIMEOUT,
  location = 'bottom-end',
  dataTrackTag = 'toast',
  dataTrackValue,
}: raiseToastProps) => {
  raise(<Toast dataTrackTag={dataTrackTag} dataTrackValue={dataTrackValue} message={message} type={type} />, {
    location,
    duration,
  });
};

export default raiseToast;
